import { render, staticRenderFns } from "./OrientacaoSinistroEssor.vue?vue&type=template&id=51403b96&scoped=true"
import script from "./OrientacaoSinistroEssor.vue?vue&type=script&lang=js"
export * from "./OrientacaoSinistroEssor.vue?vue&type=script&lang=js"
import style0 from "./OrientacaoSinistroEssor.vue?vue&type=style&index=0&id=51403b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51403b96",
  null
  
)

export default component.exports